import React from "react";
import { Linkedin } from "lucide-react";

export function LinkedInButton({ url, label = "Visit our LinkedIn page", className = "", testId = "linkedin-button" }) {
  if (!url) return null;
  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={label}
      data-testid={testId}
      className={`inline-flex items-center justify-center w-11 h-11 border border-current/40 text-current hover:text-accent hover:border-accent transition-colors ${className}`}
    >
      <Linkedin className="w-[18px] h-[18px]" strokeWidth={1.75} />
    </a>
  );
}
